// Import Views

// Dashboard
import Home from './views/Home';
import Settings from './views/Settings';

import {
  HomeIcon,
  SettingsIcon
} from './components/Icons/Icons';

export const main = [
  {
    path: '/',
    name: 'Home',
    icon: <HomeIcon color="inherit" />,
    component: Home,
    layout: '/',
  },
];

export const sidebar = [
  {
    path: 'settings',
    name: 'Settings',
    icon: <SettingsIcon color="inherit" />,
    component: Settings,
    layout: '/',
  }
];


const routes = [...main, ...sidebar];
export default routes;